import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["getExperimentChannel"]),
		isExperimentChannelA() {
			return this.getExperimentChannel === "A";
		},
		isExperimentChannelB() {
			return this.getExperimentChannel === "B";
		},
		isExperimentChannelC() {
			return this.getExperimentChannel === "C";
		},
		isExperimentChannelD() {
			return this.getExperimentChannel === "D";
		},
		experimentChannel() {
			return this.getExperimentChannel;
		},
	},
};
